define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'model/Context',
	'model/ErrorType',
	'factory/BindingsFactory',
	'state/UIState',
	'service/UIStateManager',
	
	'view/ProviderInfoView',
	'view/NavigationView',
	'identity/IdentityView',
	'identity/IdentityAttributesSelectionView',
	'identity/IdentityDecryptView',
	'view/ControlBarView',
	'view/TextView',
	
	'internal_util/StorageUtil',
	
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/AttributesSelectionState_strings'
], function (
	Util,
	UiUtil,
	Context,
	ErrorType,
	BindingsFactory,
	UIState,
	UIStateManager,
	
	ProviderInfoView,
	NavigationView,
	IdentityView,
	IdentityAttributesSelectionView,
	IdentityDecryptView,
	ControlBarView,
	TextView,
	
	StorageUtil,
	
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * AttributesSelectionState class
	 */
	function AttributesSelectionState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_identityView = new IdentityView(),
			_identityAttributesSelectionView,
			_identityDecryptView = new IdentityDecryptView(function(secret) {
					decrypt(secret, _uiStateManager.core().optionsManager().usePVRforOption(_authenticationOption));
			}),
			_controlBarView = new ControlBarView('skIdS_control-bar-attributes-selection'),
			_transmitIdentityButton,
			_authenticationOption = null,
			_requestedAttributes = null,
			_identity = null,
			_secret = null,
			_binding = null;

		// those attributes can be derived later from DateOfBirth in the backend
		var _ignored_requested_attrs = [ "http://www.skidentity.de/att/Age", "http://www.skidentity.de/att/AgeVerification" ];

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;

			_identityAttributesSelectionView = new IdentityAttributesSelectionView(_uiStateManager.core().attributesManager());
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_controlBarView.addButton(CommonStrings.back, function () {
			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				//set data to prevent redirect @see AutenticationOptionSelectionState
				_uiStateManager.change('authentication_option_selection',{});
			} else {
				_uiStateManager.back();
			}
		}, 0);

		_transmitIdentityButton = _controlBarView.addButton(Strings.transmit_identity_attributes, transmitData/*function () {
			var activationData = {
					authenticationOption : _authenticationOption,
					requestedAttributes : filterRequestedAttributes(),
					identity : _identity,
					binding : _binding,//_identity ? BindingsFactory.createPasswordBinding(_secret, _identity.getEncryptionSalt()) : null,
					secret : _secret
				};

			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				_uiStateManager.change('activation', activationData);
			} else {
				_uiStateManager.change('activation', activationData);
			}
		}*/);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		window.addEventListener('resize', function () {
			UiUtil.scrollTo(_identityDecryptView.get());
		});

		UIState.call(this, 'attributes_selection');


		// private methods
		
		function transmitData() {
		    var activationData = {
				    authenticationOption : _authenticationOption,
				    requestedAttributes : filterRequestedAttributes(),
				    identity : _identity,
				    binding : _binding,//_identity ? BindingsFactory.createPasswordBinding(_secret, _identity.getEncryptionSalt()) : null,
				    secret : _secret
			    };

		    if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
			    _uiStateManager.change('activation', activationData);
		    } else {
			    _uiStateManager.change('activation', activationData);
		    }
		}
		
		function checkAttributes(attributes) {
			var available,
                            i, j;

			for (i = 0; i < _requestedAttributes.length; i++) {
				if (_requestedAttributes[i].isRequired()) {
					available = false;

					if (_ignored_requested_attrs.includes(_requestedAttributes[i].name())) {
						available = true;
						break;
					}

					for (j = 0; j < attributes.length; j++) {
						if (attributes[j].name() === _requestedAttributes[i].name()) {
							available = true;
							break;
						}
					}

					if (!available) {
						return false;
					}
				}
			}

			return true;
		}

		function filterRequestedAttributes() {
			var selectedAttributeNames = _identityAttributesSelectionView.getSelectedAttributes(),
				selectedAttributes = new Array(),
				i, j;

			for (i = 0; i < selectedAttributeNames.length; i++) {
				for (j = 0; j < _requestedAttributes.length; j++) {
					if (selectedAttributeNames[i] === _requestedAttributes[j].name()) {
						selectedAttributes.push(_requestedAttributes[j]);
						break;
					}
				}
			}

			return selectedAttributes;
		}

		function decrypt(secret, usePVR) {
			_binding.setPVR(_identity.salt(), secret, usePVR);
			
			_secret = secret;

			_identityView.hideLoadingIndicator();

			_navigationView.update(Strings.select_identity_attributes);

			if (_identity.isUsable() && checkAttributes(_identity.attributes())) {
				_transmitIdentityButton.prop('disabled', false);
			}
			
			if (isOnlyPseudonym(_requestedAttributes)) {
				setTimeout(transmitData,250);
				//transmitData();
			} else {
				_identityAttributesSelectionView.update(_authenticationOption, _requestedAttributes, _identity, _identity.attributes());
				_identityView.changeContent(_identityAttributesSelectionView);

				UiUtil.scrollTo(_navigationView.get());
			}
		}
		
		function isOnlyPseudonym(attributes) {
//			console.info(attributes);
			
			var reqAttr = [];
			var reqAttrTest = attributes;
			for (var attr in reqAttrTest) {
			    if (reqAttrTest[attr].isRequired()) {
				reqAttr.push(reqAttrTest[attr]);
			    }
			}
			if (reqAttr.length === reqAttrTest.length && 
				reqAttr.length === 1 &&
				reqAttr[0].name() === "http://www.skidentity.de/att/eIdentifier") {
//			    console.info(true);
				return true;
			}
			
			return false;
		}


		// public methods

		this.title = function () {
			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				return _uiStateManager.core().optionsManager().providerInfo().description();
			}

			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _identityView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, activationData) {
			var authenticationOptionUi = null;

			_authenticationOption = activationData['authenticationOption'];
			_requestedAttributes = activationData['requestedAttributes']
					.concat(_authenticationOption.requestedAttributes());
			
			_requestedAttributes = Util.uniqueAttributesByName(_requestedAttributes);

			if (activationData.hasOwnProperty('identity')) {
				_identity = activationData['identity'];
			} else {
				_identity = null;
			}

			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				_providerInfoView.update(_uiStateManager.core().optionsManager().providerInfo());
				_navigationView.update(Strings.select_identity_attributes);
				_transmitIdentityButton.html(Strings.transmit_identity_attributes);
			} else {
				_providerInfoView.update(_uiStateManager.core().cloudIdentitiesManager().providerInfo());
				_navigationView.update(Strings.select_cloud_identity_attributes);
				_transmitIdentityButton.html(Strings.create_cloud_identity);
			}

			// try to use option of origin of cloudid for UI
			if (_identity !== null) {
				authenticationOptionUi = _uiStateManager.core().cloudIdentitiesManager()
						.getAuthenticationOptionForOrigin(_identity.origin());
			}
			if (authenticationOptionUi === null) {
				authenticationOptionUi = _authenticationOption;
			}
			_identityView.update(_identity, authenticationOptionUi);

			_transmitIdentityButton.prop('disabled', true);

			if (_identity !== null && _identity.isValid()) {
				_binding = _identity.bindingProtocol()[0];

				if(_binding.type() === "http://ws.skidentity.de/ci/binding/key/v1.0" && _binding.origin() === "FIDO/WebAuthn") {
					if (_uiStateManager.core().optionsManager().usePVRforOption(_authenticationOption)) {
						_navigationView.update(Strings.insert_pin);
						_identityDecryptView.update();
						_identityView.changeContent(_identityDecryptView);
					} else {
						decrypt(null, _uiStateManager.core().optionsManager().usePVRforOption(_authenticationOption));
					}
				} else {
					_navigationView.update(Strings.insert_pin);
					_identityDecryptView.update();
					_identityView.changeContent(_identityDecryptView);
				}
				
				var error = StorageUtil.read("activate_error");
				if (error && error) {
					StorageUtil.remove("activate_error");
					var msg = error.data;
					_identityDecryptView.showError(msg);
				}
			} else {
				_transmitIdentityButton.prop('disabled', false);

				_identityAttributesSelectionView.update(_authenticationOption, _requestedAttributes, null, null);
				_identityView.changeContent(_identityAttributesSelectionView);
			}
			
			Util.callCallbacks(doneCallback);
			
			UiUtil.scrollTo(_navigationView.get());
		};

		this.leave = function (doneCallback) {
			_authenticationOption = null;
			_requestedAttributes = null;
			_identity = null;
			_secret = null;

			_identityView.hideLoadingIndicator();

			Util.callCallbacks(doneCallback);
		};
	};

	AttributesSelectionState.prototype = Object.create(UIState.prototype);

	return AttributesSelectionState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/AttributesSelectionState.js
// module id = 323
// module chunks = 2